
import React, { useState } from "react";
import { Link } from "react-router-dom";
import SRList from "../component/List";
import AkkhorLayout from "../layout/akkhor";

const LOAI_LABEL = {
    single: "Trắc nghiệm 1 đáp án",
    multiple: "Trắc nghiệm nhiều đáp án",
    sort: "Sắp xếp vị trí",
    match: "Nối cột",
    essay: "Tự luận",
};

export default function DanhSachCauHoi() {
    const [params, setParam] = useState('');
    const [title, setTitle] = useState('');
    const [loai, setLoai] = useState('');
    const [filterShow, setFilterShow] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        let _param = '';
        if (title !== '') _param += "&title=" + title;
        if (loai !== '') _param += "&loai=" + loai;
        setParam(_param);
    };

    let columns = [
        { name: "id", label: "ID", options: { filter: false, sort: true } },
        {
            name: "title", label: "Nội dung",
            options: {
                customBodyRender: (value) => <div className="text-truncate" style={{ maxWidth: 360 }} dangerouslySetInnerHTML={{ __html: value }} />
            }
        },
        {
            name: "loai", label: "Loại",
            options: { customBodyRender: (value) => LOAI_LABEL[value] || value }
        },
        { name: "author_name", label: "Người tạo" },
        { name: "datecreate", label: "Ngày tạo" },
    ];

    return (<AkkhorLayout idrole="learninghub_cauhoi">
        <div className="breadcrumbs-area">
            <ul>
                <li><Link to="/">Trang chủ</Link></li>
                <li>Ngân hàng câu hỏi</li>
            </ul>
        </div>
        <div className="card card-filter mb-3">
            <div className="card-header">
                <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
                    <div className="mr-auto"><h3 className="title">Tìm kiếm</h3></div>
                    <button className="btn btn-sm btn-defaul"><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
                </div>
            </div>
            <div className={filterShow ? "card-body" : 'hidden-filter'}>
                <form className="new-added-form" method="get">
                    <div className="row">
                        <div className="col-sm-3 col-12 form-group">
                            <label>Nội dung</label>
                            <input type="text" placeholder="Nội dung câu hỏi" value={title} onChange={(e) => setTitle(e.target.value)} className="form-control height32" autoComplete="off" />
                        </div>
                        <div className="col-sm-3 col-12 form-group">
                            <label>Loại câu hỏi</label>
                            <select className="form-select height32" value={loai} onChange={(e) => setLoai(e.target.value)}>
                                <option value="">Tất cả</option>
                                {Object.keys(LOAI_LABEL).map((k) => <option key={k} value={k}>{LOAI_LABEL[k]}</option>)}
                            </select>
                        </div>
                        <div className="col-12">
                            <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <SRList name="learninghub_cauhoi" linkaction="learninghub_cauhoi" idrole="learninghub_cauhoi" params={params} defaultLimit={50} serverSide={true} columns={columns}></SRList>
    </AkkhorLayout>);
}
